import * as angular from "angular";
import {IController, IQService} from "angular";
import * as _ from "lodash";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";

export class AgentSelectByScheduleComponent implements IController {

  selectedId: any;
  agentType: any;
  carrierId?: string;
  branchIds: any;
  excludeIds: any;
  ngPlaceholder: any;
  onChange: Function;

  private agentResourceBindingsRef: any;
  private loadLimit: number = 1000;
  private searchTerm: string = '';
  private agentBindings = [];
  private selectedAgentBinding: any;

  constructor(private $infiniteScroll, private $mdSelect, private $log,
              private $q: IQService, private commonsAlertsService: CommonsAlertsService, private $agentResource) {
    this.agentResourceBindingsRef = this.$agentResource();
  }

  $onInit() {
    if (!this.excludeIds) {
      this.excludeIds = [];
    }
    if (this.selectedId) {
      this.agentResourceBindingsRef.$asyncValues([this.selectedId])
        .then((agentBindings) => {
          this.agentBindings = agentBindings;
          this.selectedAgentBinding = _.find(agentBindings, (a) => {
            return a.id === this.selectedId;
          });
        })
    }
  }

  $onChanges(changes) {
    if (changes.selectedId && !changes.selectedId.isFirstChange()) {
      this.selectedAgentBinding = _.find(this.agentBindings, (a) => {
        return a.id === this.selectedId;
      });
    }
  }

  onOpen() {
    return this.agentResourceBindingsRef.$getAll(this.getQueryPayload())
      .then((agentBindingIds) => {
        return this.agentResourceBindingsRef.$asyncValues(agentBindingIds);
      })
      .then((agentBindings) => {
        if (this.excludeIds.length) {
          agentBindings = this.filterExclude(agentBindings);
        }
        this.agentBindings = agentBindings;
      })
      .catch((error) => {
        this.commonsAlertsService.somethingWentWrongError();
        this.$log.error('Failed to get service areas @branchesMultiSelect@onOpen', error);
      })
  }

  cancel() {
    this.$mdSelect.hide();
  }

  reset() {
    this.searchTerm = '';
    this.selectedId = undefined;
    this.onChange();
    this.$mdSelect.hide();
  }

  private getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.searchTerm,
      sortByLoad: true,
      active: true,
      agentType: this.agentType,
      carrierId: this.carrierId,
      branchIds: this.branchIds || undefined
    }
  }

  private filterExclude(agentBindings) {
    return _.filter(agentBindings, (a) => {
      return _.indexOf(this.excludeIds, a.id) === -1;
    });
  }

}


angular
  .module('bringoz.admin.schedule')
  .component('agentSelectBySchedule', {
    bindings: {
      selectedId: '<',
      agentType: '<?',
      carrierId: '<?',
      branchIds: '<?',
      excludeIds: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    templateUrl: 'app/modules/schedule/components/agent-select-by-schedule/agent-select-by-schedule.html',
    controller: AgentSelectByScheduleComponent
  });
